// Salvage fragments (REPRISE.md §4) — the pieces of the unmade kingdom that
// gate district restoration. A fragment has NO gameplay stats: its only use
// is being delivered into a district that asks for it. Rarity controls
// scarcity, never power, which is what keeps a tradeable item from becoming a
// power market.
//
// DISPLAY ONLY. The authoritative drop rates and the roll itself live in
// supabase/reprise-schema.sql's pull_fragments() — fragments MUST be
// server-rolled because they're tradeable (a client roll would be a
// mint-anything exploit). This file exists so the UI can name, colour, and
// order what the server hands back. The `id` set and the relative `weight`
// ordering here must match that function; `weight` is carried only so the
// gallery can show rough scarcity, not to roll anything.

export const FRAGMENT_RARITIES = {
  common:   { id: 'common',   label: 'Common',   color: 'var(--rarity-common)' },
  uncommon: { id: 'uncommon', label: 'Uncommon', color: 'var(--green)' },
  rare:     { id: 'rare',     label: 'Rare',     color: 'var(--rarity-rare)' },
};

// One signature salvage per Quarter (REPRISE.md §2). `glyph` is a text mark —
// no art dependency, same as the rest of the game's card/pet placeholders.
export const FRAGMENTS = [
  { id: 'grain',  label: 'Grain',  quarter: 'The Long Table',   rarity: 'common',   weight: 40, glyph: '❖' },
  { id: 'cog',    label: 'Cog',    quarter: 'The Measure',      rarity: 'common',   weight: 40, glyph: '✦' },
  { id: 'ember',  label: 'Ember',  quarter: 'The Ashen Ward',   rarity: 'uncommon', weight: 24, glyph: '✸' },
  { id: 'stave',  label: 'Stave',  quarter: 'The Riven Nave',   rarity: 'uncommon', weight: 24, glyph: '𝄞' },
  { id: 'crown',  label: 'Crown',  quarter: 'The Empty Court',  rarity: 'rare',     weight: 10, glyph: '♔' },
  { id: 'mirror', label: 'Mirror', quarter: 'The Second Crown', rarity: 'rare',     weight: 10, glyph: '◈' },
];

const BY_ID = new Map(FRAGMENTS.map((f) => [f.id, f]));

export function getFragment(id) {
  return BY_ID.get(id) ?? null;
}

/** Display label for a fragment id, falling back to the raw id for anything the client doesn't know (e.g. a fragment added server-side first). */
export function fragmentLabel(id) {
  return BY_ID.get(id)?.label ?? id;
}

export function fragmentRarityColor(id) {
  const frag = BY_ID.get(id);
  return frag ? (FRAGMENT_RARITIES[frag.rarity]?.color ?? 'var(--ink)') : 'var(--ink)';
}
